"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LinkPopper;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));
var _context = require("../context");
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _OpenInBrowser = _interopRequireDefault(require("@material-ui/icons/OpenInBrowser"));
var _reactDom = require("react-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var $ = _tinymce["default"].dom.DomQuery;
function LinkPopper(_ref) {
  var linkDialogRef = _ref.linkDialogRef;
  var editor = (0, _context.useEditor)();
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    linkNode = _useState2[0],
    setLinkNode = _useState2[1];
  (0, _react.useEffect)(function () {
    var handleChangeSelection = function handleChangeSelection() {
      if (!editor.selection || !editor.selection.isCollapsed()) {
        return setLinkNode(null);
      }
      var node = editor.selection.getSel().anchorNode;
      var linksNode = $(node).parents('a[href]');
      if (linksNode.length) {
        return setLinkNode(linksNode[0]);
      }
      setLinkNode(null);
    };
    editor.on('SelectionChange', handleChangeSelection);
    return function () {
      editor.off('SelectionChange', handleChangeSelection);
    };
  }, [editor]);
  if (!linkNode) return null;
  var handleChange = function handleChange() {
    var linkContent = linkNode.text;
    var linkHref = linkNode.getAttribute('href');
    editor.selection.select(linkNode);
    linkDialogRef.current.show(linkContent, linkHref);
    setLinkNode(null);
  };
  var handleRemove = function handleRemove() {
    editor.execCommand('Unlink');
    setLinkNode(null);
  };
  var rect = linkNode.getBoundingClientRect();
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute",
    style: {
      zIndex: 100,
      transform: "translate3d(".concat(rect.left, "px, ").concat(rect.bottom, "px, 0px)")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm border rounded bg-app dark:bg-card dark:shadow-shallow shadow p-2 h-8 flex items-center",
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-primary hover:underline px-2",
    onClick: handleChange
  }, "Change"), /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    orientation: "vertical"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-primary hover:underline px-2",
    onClick: handleRemove
  }, "Remove"), /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    orientation: "vertical"
  }), /*#__PURE__*/_react["default"].createElement("a", {
    href: linkNode.getAttribute('href'),
    target: "__blank",
    className: "px-2 text-primary hover:underline inline-flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-2"
  }, "Open Link"), /*#__PURE__*/_react["default"].createElement(_OpenInBrowser["default"], {
    fontSize: "small"
  })))), editor.getContainer());
}
//# sourceMappingURL=LinkPopper.js.map